import { render, staticRenderFns } from "./CustomSourcesPage.vue?vue&type=template&id=e27dd934"
import script from "./CustomSourcesPage.vue?vue&type=script&lang=js"
export * from "./CustomSourcesPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports